import { render, staticRenderFns } from "./item-inventory-location-history.vue?vue&type=template&id=e18cdda2&scoped=true"
import script from "./item-inventory-location-history.vue?vue&type=script&setup=true&lang=js"
export * from "./item-inventory-location-history.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18cdda2",
  null
  
)

export default component.exports